import React, { createContext, useContext, useEffect, useState, useCallback } from 'react';
import { getSiteConfig } from '../services/api';

const SiteConfigContext = createContext(null);

function applyTheme(theme) {
  if (!theme) return;
  const root = document.documentElement;
  if (theme.primary) root.style.setProperty('--brand-primary', theme.primary);
  if (theme.accent)  root.style.setProperty('--brand-accent',  theme.accent);
}

export function SiteConfigProvider({ children }) {
  const [config, setConfig] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const load = useCallback(() => {
    setLoading(true);
    setError(null);
    return getSiteConfig()
      .then((c) => setConfig(c))
      .catch((err) => {
        console.error('Failed to load site config:', err);
        setError(err);
      })
      .finally(() => setLoading(false));
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  useEffect(() => {
    applyTheme(config?.theme);
  }, [config]);

  return (
    <SiteConfigContext.Provider value={{ config, loading, error, retry: load }}>
      {children}
    </SiteConfigContext.Provider>
  );
}

export function useSiteConfig() {
  const ctx = useContext(SiteConfigContext);
  if (!ctx) throw new Error('useSiteConfig must be used inside <SiteConfigProvider>');
  return ctx;
}
